import { FC } from 'react'
import { bindActionCreators } from 'redux'
import { connect, ConnectedComponent } from 'react-redux'
import { toggleOpenState } from '@cinch/oxd-redux/search/src/actions'

import Component, { RegularLayoutProps } from './regular.component'
import { SearchProps } from '../../../components/search/src/search.component'

interface StateFromReduxProps {
  search: SearchProps
}

const RegularLayout: ConnectedComponent<
  FC<RegularLayoutProps>,
  Partial<RegularLayoutProps> & { children?: React.ReactNode | React.ReactNodeArray }
> = connect(
  (state: StateFromReduxProps) => ({ searchIsOpen: state.search && state.search.isOpen }),
  (dispatch) => bindActionCreators({ toggleSearch: toggleOpenState }, dispatch),
)(Component)

export default RegularLayout
